"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMetadata = void 0;
const useFetch_1 = __importDefault(require("./useFetch"));
const useDeepMemo_1 = require("./useDeepMemo");
const lodash_1 = require("lodash");
const carbonIntensity_1 = require("../util/carbonIntensity");
const apiUtils_1 = require("../util/apiUtils");
const useMetadata = () => {
    const [rawMetadata] = (0, useFetch_1.default)("calculator/data.json", undefined);
    const [metadata] = (0, useDeepMemo_1.useDeepMemo)(() => {
        if (rawMetadata.status !== apiUtils_1.LoaderStatus.Success) {
            return [undefined];
        }
        return [
            {
                ...rawMetadata.data,
                fuels: (0, lodash_1.mapValues)(rawMetadata.data.fuels, (f) => ({
                    ...f,
                    intensity_text: (0, carbonIntensity_1.getCarbonIntensity)(f.average_intensity, rawMetadata.data.intensity_limit),
                    average_intensity: Number(f.average_intensity),
                })),
            },
        ];
    }, [rawMetadata]);
    return [metadata];
};
exports.useMetadata = useMetadata;
